//Imports 
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { db } from "../../../firebase";
import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";
import 'react-datepicker/dist/react-datepicker.css';
//Imports data
import staticData from '../../../contexts/staticData.json';
//Imports Components
import FormEditProject from "./FormEditProject";
import FormEditEstablishment from "./FormEditEstablishments";
import MessageConfirmation from "../../messageConfirmation/MessageConfirmation";
//Imports Icons
import save from '../../../assets/icons/saveIcon.svg';
//Imports CSS
import './addProjectForm.css';

const submitFirestore = async (newProject, establishments, onSuccess, onError) => {
    let projectRef = null;
    const createdEstablishmentIds = [];

    try {
        //1. Agregar el proyecto principal
        projectRef = await addDoc(collection(db, "projects"), newProject);

        // 2. Filtrar establecimientos válidos
        const validEstablishments = establishments.filter(establishment => {
            return establishment.rbd && establishment.nameEstablishment;
        });

        // 3. Crear array de promesas para todos los establecimientos
        const establishmentPromises = validEstablishments.map(async (establishment) => {
            const establishmentUUID = uuidv4();
            const establishmentData = {
                projectId: projectRef.id,  // Usar el ID del proyecto recién creado
                rbd: establishment.rbd,
                nameEstablishment: establishment.nameEstablishment,
                uid: establishmentUUID,
                region: establishment.region,
                commune: establishment.commune,
                typeEstablishment: establishment.typeEstablishment,
                createdAt: new Date().getTime()
            };
            const estRef = await addDoc(collection(db, 'establishments'), establishmentData);
            createdEstablishmentIds.push(estRef.id); // Guardar el ID del establecimiento creado
        });

        // 4. Esperar a que todas las promesas se resuelvan
        await Promise.all(establishmentPromises);

        // 5. Llamar al callback de éxito y guardar en sessionStorage
        if (typeof onSuccess === 'function') {
            onSuccess(projectRef.id);
        }
        sessionStorage.setItem('projectAdded', 'true');
    } catch (error) {
        console.error("Error en submitFirestore:", error);
        if (typeof onError === 'function') {
            onError(error);
        }
        //6. Rollback manual en caso de error
        try {
            if(projectRef?.id) await deleteDoc(doc(db, "projects", projectRef.id));
            //Borrar los establecimientos creados
            const deletePromises = createdEstablishmentIds.map(id => deleteDoc(doc(db, "establishments", id)));
            await Promise.all(deletePromises);
        } catch (cleanupError) {
            console.error("Error en la limpieza:", cleanupError);
            error.cleanupError = cleanupError;
        }
        
    }
};

function AddProjectForm() {
    const [nameProject, setNameProject] = useState('');
    const [selectRegionProject, setSelectRegionProject] = useState('');
    const [selectCommuneProject, setSelectCommuneProject] = useState('');
    const [selectDependencies, setSelectDependencies] = useState('');
    const [dateFrom, setDateFrom] = useState(null);
    const [dateUntil, setDateUntil] = useState(null);
    const [selectRegionEstablishment, setSelectRegionEstablishment] = useState('');
    const [establishments, setEstablishments] = useState([{
        rbd: '', nameEstablishment: '', region: '', commune: '', typeEstablishment: ''
    }]);
    const [messageConfirmation, setMessageConfirmation] = useState(false);
    const [messageError, setMessageError] = useState(false);// Estado para controlar el envío del formulario
    const [isFormValid, setIsFormValid] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const formIsValid = nameProject.trim() !== '' &&
            selectRegionProject !== '' &&
            selectCommuneProject !== '' &&
            selectDependencies !== '' &&
            dateFrom !== null &&
            dateUntil !== null;

        setIsFormValid(formIsValid);
    }, [nameProject, selectRegionProject, selectCommuneProject, selectDependencies, dateFrom, dateUntil]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const projectUUID = uuidv4();
        const newProject = {
            code: projectUUID.substring(0, 5),
            uid: projectUUID,
            nameProject,
            region: selectRegionProject,
            commune: selectCommuneProject,
            dependencie: selectDependencies,
            contractValidity: [
                {
                    dateFrom: dateFrom ? dateFrom.getTime() : null,
                    dateUntil: dateUntil ? dateUntil.getTime() : null,
                },
            ],
        };

        submitFirestore(newProject, establishments,
            (projectId) => {
                // Éxito - este callback puede no ejecutarse si el componente se desmonta
                setMessageConfirmation(true);
                navigate(-1);
            },
            (error) => {
                // Error - este callback puede no ejecutarse si el componente se desmonta
                setMessageError(true);
            }
        );
    };

    const regionData = staticData.regiones.find((region) => region.name === selectRegionProject);
    const regionDataEstablishment = staticData.regiones.find((region) => region.name === selectRegionEstablishment);

    return (
        <>
            <section className='container-add-projec-form flex'>
                <p>Crear Nuevo Proyecto</p>
                <form className='container-form flex' onSubmit={handleSubmit}>
                    <FormEditProject
                        nameProject={nameProject}
                        setNameProject={setNameProject}
                        selectRegionProject={selectRegionProject}
                        setSelectRegionProject={setSelectRegionProject}
                        selectCommuneProject={selectCommuneProject}
                        setSelectCommuneProject={setSelectCommuneProject}
                        selectDependencies={selectDependencies}
                        setSelectDependencies={setSelectDependencies}
                        dateFrom={dateFrom}
                        setDateFrom={setDateFrom}
                        dateUntil={dateUntil}
                        setDateUntil={setDateUntil}
                    />
                    <FormEditEstablishment
                        selectRegionEstablishment={selectRegionEstablishment}
                        setSelectRegionEstablishment={setSelectRegionEstablishment}
                        establishments={establishments}
                        setEstablishments={setEstablishments}
                    />
                    <article className='box-actions flex'>
                        <button 
                            type='submit' 
                            className={`save-project-button flex ${!isFormValid ? 'disabled' : ''}`} 
                            disabled={!isFormValid}
                        >
                            <img src={save} className='icon' alt='Icono para guardar proyecto' />
                            <p>Guardar Nuevo Proyecto</p>
                        </button>
                        <Link to='/proyectos' className='cancel'><p>Cancelar</p></Link>
                    </article>
                </form>
                <MessageConfirmation confirmation={false} error={messageError} />
            </section>
        </>
    )
};

export default AddProjectForm;